import { Link } from 'react-router-dom'
import { Channel } from '../../types'
import { ChannelProgramming } from './channel-programming'

interface ProgramProps {
  daysInterval?: number
  /** Minutes between each label on the timeline */
  timelineInterval?: number
  channel: Channel
  onProgramClick: (
    id: number | undefined,
    channel: Channel | undefined,
    date?: string | undefined
  ) => void
  isMobile?: boolean
}

export const ChannelRow = ({
  daysInterval = 6,
  timelineInterval = 30,
  channel,
  onProgramClick,
  isMobile,
}: ProgramProps) => {
  const minutePx = 200 / 30
  // const slotWidth = 200
  const totalDays = daysInterval * 2 + 1
  const days = Array.from({ length: totalDays }, (_, i) => {
    const date = new Date()
    date.setDate(date.getDate() + (i - daysInterval))
    return date.toISOString().slice(0, 10) // "YYYY-MM-DD"
  })
  const ImageWrapper = channel.isAdult ? 'span' : Link
  const isSapo = !!import.meta.env.VITE_IS_SAPO
  const language = window.ISites.WegLot?.GetCurrentLanguage() || 'PT'
  return (
    <>
      <div
        className="channel-row "
        style={{ width: `${minutePx * 24 * 60 * 13}px` }}
      >
        <div className="channel">
          <span className="channel-position">
            {channel.channelPosition}
            {channel.MEOGo.isAvailable && !isMobile && (
              <a
                href={channel.MEOGo.link}
                title={`ver canal ${channel.title} no MEO Go`}
                target="_blank"
              >
                <span className="icon-play-solid"></span>
              </a>
            )}
          </span>
          <ImageWrapper
            to={`/${
              language === 'EN' ? 'channel' : 'canal'
            }/${channel.callLetter}${
              isSapo
                ? '?utm_source=saporede-mag&utm_medium=tv-programacao&utm_campaign=guia-tv&utm_content=awa-' +
                  channel.callLetter
                : ''
            }`}
            title={`ver detalhes do canal ${channel.title}`}
            target={isSapo ? '_blank' : undefined}
          >
            <img
              src={channel.logoUrl}
              alt={`logo ${channel.title}`}
              loading="lazy"
              width="60"
              height="33"
            />
          </ImageWrapper>
        </div>
        {days.map((day, idx) => {
          return (
            <ChannelProgramming
              key={idx}
              channel={channel}
              day={day}
              daysInterval={daysInterval}
              timelineInterval={timelineInterval}
              onProgramClick={onProgramClick}
            />
          )
        })}
      </div>
    </>
  )
}
